import { useAppStore } from '@/store/appStore';
import { computed } from 'vue';

export default function useAdmin() {
  const store = useAppStore();

  return computed(() => store.isAdmin);
}
